import React, {FC} from 'react';
import Modal from 'react-bootstrap/Modal';
import {WaitListInner} from 'components/ContentPagesComponents/WaitList';
import {ModalProps} from 'utils/types/modal';

import * as styles from './styles.module.scss';

interface IWaitListModalProps {
	path: string;
	show: boolean;
	onClose: () => void;
}

const WaitListModal: FC<IWaitListModalProps> = ({show, onClose, ...props}) => {
	return (
		<Modal show={show} onHide={onClose} dialogClassName={styles.waitListDialog}>
			<Modal.Header closeButton />
			<Modal.Body className={styles.modalBody}>
				<WaitListInner {...props} className={styles.modalForm} />
			</Modal.Body>
		</Modal>
	);
};

export const WaitListModalWrapper = (path: string) => {
	const Component = (props: ModalProps) => (
		<WaitListModal {...props} path={path} />
	);
	return Component;
};

export default WaitListModal;
